import type { Band, Class, FormGroup, Set, YearGroup } from '../../types';

// Year Groups for UK secondary school (Years 7-13)
export const mockYearGroups: YearGroup[] = [
  {
    id: 'year-7',
    name: 'Year 7',
    capacity: 180,
    currentSize: 180,
  },
  {
    id: 'year-8',
    name: 'Year 8',
    capacity: 180,
    currentSize: 175,
  },
  {
    id: 'year-9',
    name: 'Year 9',
    capacity: 180,
    currentSize: 170,
  },
  {
    id: 'year-10',
    name: 'Year 10',
    capacity: 180,
    currentSize: 160,
  },
  {
    id: 'year-11',
    name: 'Year 11',
    capacity: 180,
    currentSize: 155,
  },
  {
    id: 'year-12',
    name: 'Year 12',
    capacity: 120,
    currentSize: 90,
  },
  {
    id: 'year-13',
    name: 'Year 13',
    capacity: 120,
    currentSize: 85,
  },
];

// Classes - 6 classes per year for Years 7-11, 3 for sixth form
export const mockClasses: Class[] = [
  // Year 7
  { id: 'class-7a', name: '7A', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  { id: 'class-7b', name: '7B', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  { id: 'class-7c', name: '7C', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  { id: 'class-7d', name: '7D', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  { id: 'class-7e', name: '7E', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  { id: 'class-7f', name: '7F', yearGroupId: 'year-7', capacity: 30, currentSize: 30 },
  // Year 8
  { id: 'class-8a', name: '8A', yearGroupId: 'year-8', capacity: 30, currentSize: 29 },
  { id: 'class-8b', name: '8B', yearGroupId: 'year-8', capacity: 30, currentSize: 29 },
  { id: 'class-8c', name: '8C', yearGroupId: 'year-8', capacity: 30, currentSize: 29 },
  { id: 'class-8d', name: '8D', yearGroupId: 'year-8', capacity: 30, currentSize: 29 },
  { id: 'class-8e', name: '8E', yearGroupId: 'year-8', capacity: 30, currentSize: 30 },
  { id: 'class-8f', name: '8F', yearGroupId: 'year-8', capacity: 30, currentSize: 29 },
  // Year 9
  { id: 'class-9a', name: '9A', yearGroupId: 'year-9', capacity: 30, currentSize: 28 },
  { id: 'class-9b', name: '9B', yearGroupId: 'year-9', capacity: 30, currentSize: 28 },
  { id: 'class-9c', name: '9C', yearGroupId: 'year-9', capacity: 30, currentSize: 29 },
  { id: 'class-9d', name: '9D', yearGroupId: 'year-9', capacity: 30, currentSize: 28 },
  { id: 'class-9e', name: '9E', yearGroupId: 'year-9', capacity: 30, currentSize: 29 },
  { id: 'class-9f', name: '9F', yearGroupId: 'year-9', capacity: 30, currentSize: 28 },
  // Year 10
  { id: 'class-10a', name: '10A', yearGroupId: 'year-10', capacity: 30, currentSize: 27 },
  { id: 'class-10b', name: '10B', yearGroupId: 'year-10', capacity: 30, currentSize: 27 },
  { id: 'class-10c', name: '10C', yearGroupId: 'year-10', capacity: 30, currentSize: 26 },
  { id: 'class-10d', name: '10D', yearGroupId: 'year-10', capacity: 30, currentSize: 27 },
  { id: 'class-10e', name: '10E', yearGroupId: 'year-10', capacity: 30, currentSize: 27 },
  { id: 'class-10f', name: '10F', yearGroupId: 'year-10', capacity: 30, currentSize: 26 },
  // Year 11
  { id: 'class-11a', name: '11A', yearGroupId: 'year-11', capacity: 30, currentSize: 26 },
  { id: 'class-11b', name: '11B', yearGroupId: 'year-11', capacity: 30, currentSize: 26 },
  { id: 'class-11c', name: '11C', yearGroupId: 'year-11', capacity: 30, currentSize: 26 },
  { id: 'class-11d', name: '11D', yearGroupId: 'year-11', capacity: 30, currentSize: 25 },
  { id: 'class-11e', name: '11E', yearGroupId: 'year-11', capacity: 30, currentSize: 26 },
  { id: 'class-11f', name: '11F', yearGroupId: 'year-11', capacity: 30, currentSize: 26 },
  // Year 12
  { id: 'class-12a', name: '12A', yearGroupId: 'year-12', capacity: 40, currentSize: 30 },
  { id: 'class-12b', name: '12B', yearGroupId: 'year-12', capacity: 40, currentSize: 30 },
  { id: 'class-12c', name: '12C', yearGroupId: 'year-12', capacity: 40, currentSize: 30 },
  // Year 13
  { id: 'class-13a', name: '13A', yearGroupId: 'year-13', capacity: 40, currentSize: 28 },
  { id: 'class-13b', name: '13B', yearGroupId: 'year-13', capacity: 40, currentSize: 28 },
  { id: 'class-13c', name: '13C', yearGroupId: 'year-13', capacity: 40, currentSize: 29 },
];

// Form Groups (tutor groups) - same structure as classes for simplicity
export const mockFormGroups: FormGroup[] = mockClasses.map((c) => ({
  id: `form-${c.id.replace('class-', '')}`,
  name: c.name.replace(/^(\d+)([A-F])$/, '$1$2 Form'),
  yearGroupId: c.yearGroupId,
  tutorId: undefined, // Will be assigned from teacher data
  capacity: c.capacity,
  currentSize: c.currentSize,
}));

// Sets - ability grouping for Mathematics and English
export const mockSets: Set[] = [
  // Year 7 Maths
  {
    id: 'set-y7-math-1',
    name: 'Year 7 Maths Set 1',
    subjectId: 'subject-math',
    yearGroupId: 'year-7',
    targetAbilityLevel: 'high',
    capacity: 25,
    currentSize: 24,
  },
  {
    id: 'set-y7-math-2',
    name: 'Year 7 Maths Set 2',
    subjectId: 'subject-math',
    yearGroupId: 'year-7',
    targetAbilityLevel: 'high',
    capacity: 25,
    currentSize: 25,
  },
  {
    id: 'set-y7-math-3',
    name: 'Year 7 Maths Set 3',
    subjectId: 'subject-math',
    yearGroupId: 'year-7',
    targetAbilityLevel: 'medium',
    capacity: 25,
    currentSize: 25,
  },
  {
    id: 'set-y7-math-4',
    name: 'Year 7 Maths Set 4',
    subjectId: 'subject-math',
    yearGroupId: 'year-7',
    targetAbilityLevel: 'medium',
    capacity: 25,
    currentSize: 24,
  },
  // Year 8 Maths
  {
    id: 'set-y8-math-1',
    name: 'Year 8 Maths Set 1',
    subjectId: 'subject-math',
    yearGroupId: 'year-8',
    targetAbilityLevel: 'high',
    capacity: 25,
    currentSize: 23,
  },
  {
    id: 'set-y8-math-2',
    name: 'Year 8 Maths Set 2',
    subjectId: 'subject-math',
    yearGroupId: 'year-8',
    targetAbilityLevel: 'high',
    capacity: 25,
    currentSize: 24,
  },
  {
    id: 'set-y8-math-3',
    name: 'Year 8 Maths Set 3',
    subjectId: 'subject-math',
    yearGroupId: 'year-8',
    targetAbilityLevel: 'medium',
    capacity: 25,
    currentSize: 24,
  },
  {
    id: 'set-y8-math-4',
    name: 'Year 8 Maths Set 4',
    subjectId: 'subject-math',
    yearGroupId: 'year-8',
    targetAbilityLevel: 'medium',
    capacity: 25,
    currentSize: 23,
  },
];

// Bands - cross-curricular grouping for humanities subjects
export const mockBands: Band[] = [
  {
    id: 'band-y9-humanities-1',
    name: 'Year 9 Humanities Band 1',
    yearGroupId: 'year-9',
    subjects: ['subject-history', 'subject-geography', 'subject-rs'],
    description: 'High ability humanities grouping',
    capacity: 85,
    currentSize: 82,
  },
  {
    id: 'band-y9-humanities-2',
    name: 'Year 9 Humanities Band 2',
    yearGroupId: 'year-9',
    subjects: ['subject-history', 'subject-geography', 'subject-rs'],
    description: 'Mixed ability humanities grouping',
    capacity: 88,
    currentSize: 88,
  },
];

// Helper functions
export const getYearGroupById = (id: string) => mockYearGroups.find((yg) => yg.id === id);

export const getClassesByYearGroup = (yearGroupId: string) => mockClasses.filter((c) => c.yearGroupId === yearGroupId);

export const getFormGroupsByYearGroup = (yearGroupId: string) =>
  mockFormGroups.filter((fg) => fg.yearGroupId === yearGroupId);

export const getSetsByYearGroup = (yearGroupId: string) => mockSets.filter((s) => s.yearGroupId === yearGroupId);

export const getBandsByYearGroup = (yearGroupId: string) => mockBands.filter((b) => b.yearGroupId === yearGroupId);
